import React, { ReactNode } from 'react';
import SideBar from '../../containers/SideBar';
import styles from './Page.module.css';

interface PageProps {
  children: ReactNode;
}

export const Page = (props: PageProps) => {
  return (
    <div className={styles.root}>
      <SideBar />
      <div className={styles.page}>
        {props.children}
      </div>
    </div>
  );
};

export default Page;
